import { render, staticRenderFns } from "./GenericDimensionRowText.vue?vue&type=template&id=74ffc647&scoped=true"
import script from "./GenericDimensionRowText.vue?vue&type=script&lang=js"
export * from "./GenericDimensionRowText.vue?vue&type=script&lang=js"
import style0 from "./GenericDimensionRowText.vue?vue&type=style&index=0&id=74ffc647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ffc647",
  null
  
)

export default component.exports